import { Component, OnInit, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HomeService } from '../_services/home.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { browserRefresh } from '../app.component';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  @ViewChild('content') content;
  notifications: any[] = [];
  institutions: any;
  allNotifications: any[] = [];
  pk: any;
  title: any;
  type: any;
  data: any;
  notificationActive: boolean= false;
  closed: boolean=false;
  public browserRefresh: boolean;
  count:any = 0;

  constructor(private homeService: HomeService, private modalService: NgbModal, private router: Router, public sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.browserRefresh = browserRefresh;
    this.getAllNotification();
  }

  getAllNotification(){
    this.homeService.getAllNotifications().subscribe(res=>{
      this.notifications = res.return_body;
      for(let i=0;i<this.notifications.length;i++){
        if(this.notifications[i].type==="NOTIFICATION_SELFHELP"){
          this.count = this.count+1;
        }
        this.notifications[i].data = this.sanitizer.bypassSecurityTrustHtml(this.notifications[i].data)
      }
      if(this.count>0){
        this.openModal();
      }
    })
  }

  openModal() {
      this.modalService.open(this.content);
  }

  closeModal() {
    this.modalService.dismissAll('Cross click');
    this.router.navigate([this.router.url.split("/")[1],'home']);
  }
}
